<template>
  <div id="app" :class="(isIframePlayer || isEmbedPlayer) && 'appDarkBackground'">
    <notifications :duration="5000" classes="custom-notification" />
    <template v-if="isIframePlayer || isEmbedPlayer">
      <RouterView />
    </template>
    <template v-else>
      <template v-if="userLoggedIn">
        <nav v-if="user.type === 'admin'" class="navbar navbar-default navbar-admin">
          <div class="container">
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#navbar-collapse-admin"
                aria-expanded="false"
              >
                <span class="sr-only">Toggle navigation</span>
                <i class="icon-menu" />
              </button>
              <RouterLink to="/" class="navbar-brand" />
            </div>
            <div id="navbar-collapse-admin" class="navbar-collapse collapse">
              <ul class="nav navbar-nav navbar-right">
                <template v-if="user.type === 'admin'">
                  <RouterLink tag="li" :to="{ path: '/admin/podcasts' }"><a>Content</a></RouterLink>
                  <RouterLink tag="li" :to="{ path: '/admin/notifications' }"><a>Notifications</a> </RouterLink>
                  <RouterLink tag="li" :to="{ path: '/admin/stats' }"><a>Statistics</a></RouterLink>
                  <RouterLink tag="li" :to="{ path: '/admin/career' }"><a>Career</a></RouterLink>
                  <RouterLink tag="li" :to="{ path: '/admin/users' }"><a>Users</a></RouterLink>
                  <hr class="navbar-mobile-item" />
                  <RouterLink class="navbar-mobile-item" tag="li" :to="{ path: '/admin/my_account' }"
                    ><a>My Account</a></RouterLink
                  >
                  <li class="navbar-mobile-item"><a href="#" @click.prevent="logOut">Log out</a></li>
                </template>

                <template v-else-if="user.type === 'advertiser'">
                  <RouterLink tag="li" :to="{ path: '/advertiser/dashboard' }" exact><a>Dashboard</a></RouterLink>
                  <RouterLink tag="li" :to="{ path: '/advertiser/ads' }"><a>Ads</a></RouterLink>
                  <RouterLink tag="li" :to="{ path: '/advertiser/stats' }"><a>Statistics</a></RouterLink>
                  <hr class="navbar-mobile-item" />
                  <RouterLink tag="li" class="navbar-mobile-item" :to="{ path: '/advertiser/my_account' }"
                    ><a>My Account</a></RouterLink
                  >
                  <li class="navbar-mobile-item"><a href="#" @click.prevent="logOut">Log out</a></li>
                </template>

                <li class="dropdown loggedin-user-dropdown">
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div class="profile-image bg bg-cover" :style="{ backgroundImage: `url(${user.image})` }" />
                    <div class="user-name">{{ user.name }}<span class="caret" /></div>
                  </a>
                  <ul class="dropdown-menu">
                    <template v-if="user.type === 'admin'">
                      <RouterLink tag="li" :to="{ path: '/admin/my_account' }"><a>My Account</a> </RouterLink>
                    </template>

                    <template v-else-if="user.type === 'podcaster'">
                      <RouterLink tag="li" :to="{ path: '/podcaster/my_account' }"><a>My Account</a> </RouterLink>
                    </template>

                    <template v-if="user.type === 'advertiser'">
                      <RouterLink tag="li" :to="{ path: '/advertiser/my_account' }"><a>My Account</a> </RouterLink>
                    </template>

                    <li><a href="#" @click.prevent="logOut">Log out</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <template v-else>
          <div class="searchbar">
            <div class="search-field">
              <div class="container">
                <form>
                  <span v-if="showSpinner" class="search-spinner-container">
                    <i class="fa fa-spinner fa-spin afripods-spinner" />
                  </span>
                  <input
                    id="search-input"
                    type="text"
                    placeholder="Search..."
                    autocomplete="off"
                    @keydown.enter.prevent
                  />
                </form>
                <a href="#" class="search-btn search-close" @click.prevent="closeSearchBar"><i class="icon-close" /></a>
              </div>
            </div>
            <div class="search-results">
              <div class="container">
                <div class="row gutter-40">
                  <div v-if="searchResultsNetworks.length > 0" class="search-results__category col-sm-6 col-md-3">
                    <div class="heading heading__xs">Networks</div>

                    <template v-for="(network, index) in searchResultsNetworks">
                      <RouterLink
                        v-if="index < 5"
                        :key="index"
                        :to="{
                          name: 'Network',
                          params: { slug: network.slug || network.id },
                        }"
                        class="search-results__list"
                      >
                        <div
                          class="image bg bg-cover"
                          :style="{
                            backgroundImage: `url(${network.image})`,
                          }"
                        />
                        <div class="caption">
                          <strong class="caption-title">{{ network.name }}</strong>
                        </div>
                      </RouterLink>
                    </template>
                  </div>
                  <div v-if="searchResultsStations.length > 0" class="search-results__category col-sm-6 col-md-3">
                    <div class="heading heading__xs">Stations</div>

                    <template v-for="(station, index) in searchResultsStations">
                      <RouterLink
                        v-if="index < 5"
                        :key="index"
                        :to="{
                          name: 'Station',
                          params: { slug: station.slug || station.id },
                        }"
                        class="search-results__list"
                      >
                        <div
                          class="image bg bg-cover"
                          :style="{
                            backgroundImage: `url(${station.image})`,
                          }"
                        />
                        <div class="caption">
                          <strong class="caption-title">{{ station.name }}</strong>
                          <span class="caption-title__lead">{{ station.ownerName }}</span>
                        </div>
                      </RouterLink>
                    </template>
                  </div>
                  <div v-if="searchResultsPodcasts.length > 0" class="search-results__category col-sm-6 col-md-3">
                    <div class="heading heading__xs">Podcasts</div>

                    <template v-for="(podcast, index) in searchResultsPodcasts">
                      <RouterLink
                        v-if="index < 5"
                        :key="index"
                        :to="{
                          name: 'Podcast',
                          params: { slug: podcast.slug || podcast.id },
                        }"
                        class="search-results__list"
                      >
                        <div
                          class="image bg bg-cover"
                          :style="{
                            backgroundImage: `url(${podcast.image})`,
                          }"
                        />
                        <div class="caption">
                          <strong class="caption-title">{{ podcast.title }}</strong>
                          <span class="caption-title__lead">{{ podcast.author }}</span>
                        </div>
                      </RouterLink>
                    </template>
                  </div>
                  <div v-if="searchResultsEpisodes.length > 0" class="search-results__category col-sm-6 col-md-3">
                    <div class="heading heading__xs">Episodes</div>

                    <template v-for="(episode, index) in searchResultsEpisodes">
                      <RouterLink
                        v-if="index < 5"
                        :key="index"
                        :to="{
                          name: 'Episode',
                          params: { episodeId: episode.id, seoURL: seoURL(episode.title) },
                        }"
                        class="search-results__list"
                      >
                        <div
                          class="image bg bg-cover"
                          :style="{
                            backgroundImage: `url(${episode.image})`,
                          }"
                        />
                        <div class="caption">
                          <strong class="caption-title">{{ episode.title }}</strong>
                          <span class="caption-title__lead">{{ episode.author }}</span>
                        </div>
                      </RouterLink>
                    </template>
                  </div>

                  <div v-show="noSearchResults" class="col-sm-12 no-results">
                    No such results found for your search query
                  </div>
                </div>
              </div>
            </div>
            <!--/.search-results -->
          </div>
          <!--/.searchbar -->
          <nav class="navbar navbar-default navbar-listener">
            <div class="container">
              <div class="navbar-header">
                <button
                  type="button"
                  class="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#navbar-collapse-listener"
                  aria-expanded="false"
                >
                  <span class="sr-only">Toggle navigation</span>
                  <i class="icon-menu" />
                </button>
                <RouterLink to="/" class="navbar-brand" />
              </div>
              <div id="navbar-collapse-listener" class="navbar-collapse collapse">
                <div class="navbar-exit-icon-mobile">
                  <button
                    type="button"
                    class="navbar-toggle collapsed"
                    data-toggle="collapse"
                    data-target="#navbar-collapse-listener"
                    aria-expanded="false"
                    aria-controls="navbar"
                  >
                    <i class="icon-close" />
                  </button>
                </div>
                <ul class="nav navbar-nav navbar-left">
                  <RouterLink tag="li" :to="{ path: '/listen' }" exact>
                    <a>Listen</a>
                  </RouterLink>
                  <RouterLink tag="li" :to="{ path: '/become_advertiser' }" exact><a>Advertiser</a> </RouterLink>
                  <RouterLink tag="li" :to="{ path: '/creator' }" exact><a>Creator</a> </RouterLink>
                  <RouterLink tag="li" :to="{ path: '/b2p' }" exact><a>Broadcast to Podcast</a> </RouterLink>
                  <RouterLink tag="li" :to="{ path: '/blog' }" exact><a>Blog</a> </RouterLink>
                  <RouterLink tag="li" :to="{ path: '/about' }" exact>
                    <a>About us</a>
                  </RouterLink>

                  <template v-if="user.hasPodcast">
                    <li class="menu-item-podcaster dropdown">
                      <a
                        href="#"
                        class="dropdown-toggle"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        ><div class="user-name">Podcaster dashboard<span class="caret" /></div>
                      </a>
                      <ul class="dropdown-menu">
                        <RouterLink class="desktop-item" tag="li" :to="{ path: '/podcaster/dashboard' }"
                          ><a>Dashboard</a>
                        </RouterLink>
                        <RouterLink class="desktop-item" tag="li" :to="{ path: '/podcaster/podcasts/episodes' }"
                          ><a>Content</a>
                        </RouterLink>
                        <RouterLink class="desktop-item" tag="li" :to="{ path: '/podcaster/stats' }"
                          ><a>Statistics</a></RouterLink
                        >
                        <RouterLink
                          v-if="canViewPayments"
                          class="desktop-item"
                          tag="li"
                          :to="{ path: '/podcaster/payments' }"
                          ><a>Payout dashboard</a></RouterLink
                        >
                      </ul>
                    </li>
                  </template>
                  <hr class="navbar-mobile-item orange" />
                  <RouterLink
                    v-if="!user.hasPodcast"
                    class="navbar-mobile-item mobile-item small orange"
                    tag="li"
                    :to="{ path: '/become_podcaster' }"
                    ><a>Become a podcaster</a>
                  </RouterLink>
                  <RouterLink
                    v-else
                    tag="li"
                    class="navbar-mobile-item mobile-item small"
                    :to="{ path: '/podcaster/my_account' }"
                    ><a>My Account</a>
                  </RouterLink>
                  <RouterLink class="navbar-mobile-item mobile-item small" tag="li" :to="{ path: '/listener/shows' }"
                    ><a>Shows</a></RouterLink
                  >
                  <RouterLink class="navbar-mobile-item mobile-item small" tag="li" :to="{ path: '/listener/saved' }"
                    ><a>Saved</a></RouterLink
                  >
                  <li
                    class="navbar-mobile-item mobile-item small"
                    data-toggle="modal"
                    data-target="#changePasswordModal"
                  >
                    <a>Change Password</a>
                  </li>
                  <li class="navbar-mobile-item mobile-item small" data-toggle="modal" data-target="#changeEmailModal">
                    <a>Change Email</a>
                  </li>
                  <li class="navbar-mobile-item mobile-item small">
                    <a href="#" @click.prevent="logOut">Log out</a>
                  </li>
                </ul>

                <ul class="listener-menu nav navbar-nav">
                  <div class="navbar-buttons-container">
                    <div class="search-container">
                      <a href="#" class="search-btn" @click.prevent="openSearchBar"><i class="icon-search-v2" /></a>
                    </div>
                  </div>
                  <li class="dropdown loggedin-user-dropdown">
                    <a
                      href="#"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <div class="profile-image bg bg-cover" :style="{ backgroundImage: `url(${user.image})` }" />
                      <div class="user-name">{{ user.name }}<span class="caret" /></div>
                    </a>
                    <ul class="dropdown-menu">
                      <li v-if="!user.hasPodcast" class="podcaster-register">
                        <RouterLink tag="a" :to="{ path: '/become_podcaster' }">Become a podcaster</RouterLink>
                      </li>
                      <RouterLink v-else tag="li" :to="{ path: '/podcaster/my_account' }"
                        ><a>My Account</a>
                      </RouterLink>
                      <RouterLink class="desktop-item" tag="li" :to="{ path: '/listener/shows' }"
                        ><a>Shows</a></RouterLink
                      >
                      <RouterLink class="desktop-item" tag="li" :to="{ path: '/listener/saved' }"
                        ><a>Saved</a></RouterLink
                      >
                      <li>
                        <a data-toggle="modal" data-target="#changePasswordModal">Change Password</a>
                      </li>
                      <li>
                        <a data-toggle="modal" data-target="#changeEmailModal">Change Email</a>
                      </li>
                      <li>
                        <a href="#" @click.prevent="logOut"
                          ><svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5"
                              stroke="#111111"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.333 14.1663L17.4997 9.99967L13.333 5.83301"
                              stroke="#111111"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17.5 10H7.5"
                              stroke="#111111"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          Log out</a
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </template>
      </template>
      <template v-else>
        <div class="searchbar">
          <div class="search-field">
            <div class="container">
              <form>
                <span v-if="showSpinner" class="search-spinner-container">
                  <i class="fa fa-spinner fa-spin afripods-spinner" />
                </span>
                <input
                  id="search-input"
                  type="text"
                  placeholder="Search..."
                  autocomplete="off"
                  @keydown.enter.prevent
                />
              </form>
              <a href="#" class="search-btn search-close" @click.prevent="closeSearchBar"><i class="icon-close" /></a>
            </div>
          </div>
          <div class="search-results">
            <div class="container">
              <div class="row gutter-40">
                <div v-if="searchResultsNetworks.length > 0" class="search-results__category col-sm-6 col-md-3">
                  <div class="heading heading__xs">Networks</div>

                  <template v-for="(network, index) in searchResultsNetworks">
                    <RouterLink
                      v-if="index < 5"
                      :key="index"
                      :to="{
                        name: 'Network',
                        params: { slug: network.slug || network.id },
                      }"
                      class="search-results__list"
                    >
                      <div class="image bg bg-cover" :style="{ backgroundImage: `url(${network.image})` }" />
                      <div class="caption">
                        <strong class="caption-title">{{ network.name }}</strong>
                      </div>
                    </RouterLink>
                  </template>
                </div>
                <div v-if="searchResultsStations.length > 0" class="search-results__category col-sm-6 col-md-3">
                  <div class="heading heading__xs">Stations</div>

                  <template v-for="(station, index) in searchResultsStations">
                    <RouterLink
                      v-if="index < 5"
                      :key="index"
                      :to="{
                        name: 'Station',
                        params: { slug: station.slug || station.id },
                      }"
                      class="search-results__list"
                    >
                      <div class="image bg bg-cover" :style="{ backgroundImage: `url(${station.image})` }" />
                      <div class="caption">
                        <strong class="caption-title">{{ station.name }}</strong>
                        <span class="caption-title__lead">{{ station.ownerName }}</span>
                      </div>
                    </RouterLink>
                  </template>
                </div>
                <div v-if="searchResultsPodcasts.length > 0" class="search-results__category col-sm-6 col-md-3">
                  <div class="heading heading__xs">Podcasts</div>

                  <template v-for="(podcast, index) in searchResultsPodcasts">
                    <RouterLink
                      v-if="index < 5"
                      :key="index"
                      :to="{
                        name: 'Podcast',
                        params: { slug: podcast.slug || podcast.id },
                      }"
                      class="search-results__list"
                    >
                      <div class="image bg bg-cover" :style="{ backgroundImage: `url(${podcast.image})` }" />
                      <div class="caption">
                        <strong class="caption-title">{{ podcast.title }}</strong>
                        <span class="caption-title__lead">{{ podcast.author }}</span>
                      </div>
                    </RouterLink>
                  </template>
                </div>
                <div v-if="searchResultsEpisodes.length > 0" class="search-results__category col-sm-6 col-md-3">
                  <div class="heading heading__xs">Episodes</div>

                  <template v-for="(episode, index) in searchResultsEpisodes">
                    <RouterLink
                      v-if="index < 5"
                      :key="index"
                      :to="{
                        name: 'Episode',
                        params: { episodeId: episode.id, seoURL: seoURL(episode.title) },
                      }"
                      class="search-results__list"
                    >
                      <div class="image bg bg-cover" :style="{ backgroundImage: `url(${episode.image})` }" />
                      <div class="caption">
                        <strong class="caption-title">{{ episode.title }}</strong>
                        <span class="caption-title__lead">{{ episode.author }}</span>
                      </div>
                    </RouterLink>
                  </template>
                </div>

                <div v-show="noSearchResults" class="col-sm-12 no-results">
                  No such results found for your search query
                </div>
              </div>
            </div>
          </div>
          <!--/.search-results -->
        </div>
        <!--/.searchbar -->

        <nav class="navbar navbar-default navbar-general" :class="{ transparent: transparentNav }">
          <div class="container">
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#navbar-collapse-general"
                aria-expanded="false"
                aria-controls="navbar"
              >
                <span class="sr-only">Toggle navigation</span>
                <i class="icon-menu" />
              </button>
              <RouterLink to="/" class="navbar-brand" />
            </div>
            <div id="navbar-collapse-general" class="navbar-collapse collapse">
              <div class="navbar-exit-icon-mobile">
                <button
                  type="button"
                  class="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#navbar-collapse-general"
                  aria-expanded="false"
                  aria-controls="navbar"
                >
                  <i class="icon-close" />
                </button>
              </div>
              <ul class="nav navbar-nav navbar-right navbar-custom-mod">
                <RouterLink tag="li" :to="{ path: '/creator' }" exact><a>Create</a> </RouterLink>
                <RouterLink tag="li" :to="{ path: '/listen' }" exact>
                  <a>Listen</a>
                </RouterLink>

                <RouterLink tag="li" :to="{ name: 'GhostPage', params: { slug: 'monetization' } }">
                  <a>Monetization</a>
                </RouterLink>
                <RouterLink tag="li" :to="{ path: '/blog' }" exact><a>Blog</a> </RouterLink>
                <RouterLink tag="li" :to="{ path: '/b2p' }" exact><a>Broadcast to Podcast</a> </RouterLink>

                <div class="navbar-buttons-container">
                  <div class="search-container">
                    <a href="#" class="search-btn" @click.prevent="openSearchBar"><i class="icon-search-v2" /></a>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-orange navbar-login-button desktop-item"
                    data-toggle="modal"
                    data-target="#loginModal"
                    @click="
                      () => {
                        collapseAllNavbars()
                        setLoginType('podcaster')
                      }
                    "
                  >
                    Log in / Register
                  </button>
                  <span
                    class="mobile-item button-arrow btn btn-sm btn-blue mobile-login-btn"
                    data-toggle="modal"
                    data-target="#loginModal"
                    @click="
                      () => {
                        collapseAllNavbars()
                        setLoginType('listener')
                      }
                    "
                    >Log in to your account <i class="button-arrow-icon icon-arrow"
                  /></span>
                  <RouterLink
                    tag="span"
                    data-toggle="collapse"
                    data-target="#navbar-collapse-general"
                    :to="{ path: '/register' }"
                    class="mobile-item button-arrow btn btn-sm mobile-register-btn"
                    >Create an account <i class="button-arrow-icon icon-arrow" />
                  </RouterLink>
                </div>
              </ul>
            </div>
            <!--/.nav-collapse -->
          </div>
          <!--/.container -->
        </nav>
      </template>
      <div id="afripods-content">
        <SkeletonBody>
          <template #content>
            <RouterView />
          </template>
        </SkeletonBody>
        <FooterSection :lt="lt" :user-logged-in="userLoggedIn" @ltchanged="updatelt" />
        <AudioPlayer />
      </div>
    </template>
  </div>
  <!--/#app -->
</template>

<script>
import auth from 'auth'
import AudioPlayer from 'components/AudioPlayer/AudioPlayer'
import FooterSection from 'components/reused-components/footer-section/FooterSection'
import SkeletonBody from 'components/reused-components/skeletonBody/SkeletonBody'
import config from 'conf'
import { seoURL } from 'filters'
import { event, isValidUrl, scrollToHash } from 'utils'
import isAuthorizedPaymentsUser from 'utils/payments-users'
import { StatisticsHelper } from 'utils/Statistics/StatisticsHelper'

export default {
  name: 'App',
  components: {
    AudioPlayer,
    FooterSection,
    SkeletonBody,
  },
  data() {
    return {
      lt: 'listener',
      searchResultsEpisodes: [],
      searchResultsPodcasts: [],
      searchResultsCategories: [],
      searchResultsNetworks: [],
      searchResultsStations: [],
      trendingPodcasts: [],
      podcastList: [],
      podcastCategories: [],
      podcastCategoriesMore: [],
      allPodcastCategoriesMore: [],
      featuredPodcastsList: [],
      featuredPodcastsColors: [],
      currentCatId: '',
      featuredPodcastActiveColor: '',
      transparentNav: false,
      userLoggedIn: false,
      noSearchResults: false,
      showSpinner: false,
      isIframePlayer: null,
      isEmbedPlayer: null,
      user: {
        id: '',
        type: '',
        name: '',
        image: 'static/images/temp-profile.png',
        hasPodcast: false,
      },
    }
  },
  computed: {
    canViewPayments() {
      return process.env.FEATURE_FILTER_PAYMENTS_USERS === 'true' ? isAuthorizedPaymentsUser(this.user.id) : true
    },
  },
  watch: {
    '$route.name': {
      handler(newId, oldId) {
        this.transparentNav = newId === 'Podcast' || newId === 'Episode'
        this.isIframePlayer = newId === 'iframe-player'
        this.isEmbedPlayer = newId === 'embedplayer' || newId === 'embedarchiveplayer'

        if (newId !== oldId) {
          $('#loginModal').modal('hide')
        }
      },
    },
  },
  beforeCreate() {
    this.isIframePlayer = this.$route.name === 'iframe-player'
    this.isEmbedPlayer = this.$route.name === 'embedplayer'
  },
  created() {
    // Create a session id when a user comes on the site.
    StatisticsHelper.createSessionId()

    // Setting the nav
    if (auth.checkToken()) {
      setTimeout(() => {
        event.$emit('setLoggedInUserInfo')
      }, 200)
    }
  },
  mounted() {
    if (this.getHash() === '#recover-password') {
      $('#retrievePasswordModal').modal()
    }

    const self = this
    let typingTimer // timer identifier
    const doneTypingInterval = 400 // time in ms, 5 second for example
    $('.search-results').slideUp()
    $('#search-input').on('keyup', function (event) {
      if (event.key === 'Enter') return

      const query = $(this).val()

      if (query.length > 2) {
        self.showSpinner = true
        clearTimeout(typingTimer)
        typingTimer = setTimeout(() => {
          self.executeSearch(query)
        }, doneTypingInterval)
      }
    })

    $('#search-input').on('keydown', () => {
      clearTimeout(typingTimer)
    })

    event.$on('hideSearchBar', () => {
      self.closeSearchBar()
    })

    // sets logged in user info in navbar
    event.$on('setLoggedInUserInfo', function () {
      if (localStorage.getItem('afripodsLoggedInAccountType') == null) {
        self.userLoggedIn = false
      } else {
        self.user.id = localStorage.getItem('afripodsLoggedInUserId')
        self.user.name = localStorage.getItem('afripodsLoggedInUserName')
        self.user.type = localStorage.getItem('afripodsLoggedInAccountType')
        self.user.image =
          localStorage.getItem('afripodsLoggedInUserImage') === 'null'
            ? '/static/images/icons/avatar.svg'
            : config.image.user.thumb + localStorage.getItem('afripodsLoggedInUserImage')
        self.user.hasPodcast = JSON.parse(localStorage.getItem('afripodsLoggedInUserHasPodcasts'))
        self.userLoggedIn = true
        this.$http
          .get(config.url.listener_dashboard, {
            params: {},
            headers: auth.getAuthHeader(),
          })
          .then(
            (response) => {
              const { data } = response.body
              localStorage.setItem('userShows', JSON.stringify(data.shows))
              localStorage.setItem('userBookmarks', JSON.stringify(data.bookmarks))
              localStorage.setItem('userEpisodes', data.episodes)
              self.$forceUpdate()
            },
            function (error) {
              if (error.status === '401') {
                auth.logout(this)
              }
            }
          )
      }
    })

    event.$on('logOutUser', () => {
      self.user = { name: '', type: '', image: '' }
      self.userLoggedIn = false
    })

    document.getElementById('app').addEventListener('scroll', this.handleScroll)
  },
  methods: {
    seoURL,
    scrollToHash,
    getHash() {
      return location.hash
    },
    handleScroll() {
      if (this.transparentNav) {
        if ($('#app').scrollTop() > 100) {
          $('.navbar-general').removeClass('transparent')
        } else {
          $('.navbar-general').addClass('transparent')
        }
      }
    },
    logOut() {
      auth.logout(this)
      this.$router.go()
    },
    closeSearchBar() {
      $('.search-field').slideUp(500)
      $('.search-results').slideUp(200)
    },
    openSearchBar() {
      $('.searchbar').addClass('is-visible')
      $('.search-field').fadeIn(200)
      $('#search-input').focus()

      if (
        this.searchResultsEpisodes.length > 0 ||
        this.searchResultsPodcasts.length > 0 ||
        this.searchResultsCategories.length > 0 ||
        this.searchResultsNetworks.length > 0 ||
        this.searchResultsStations.length > 0
      ) {
        $('.search-results').slideDown()
      }
    },
    executeSearch(query) {
      const vue = this

      vue.searchResultsEpisodes = []
      vue.searchResultsPodcasts = []
      vue.searchResultsCategories = []
      vue.searchResultsNetworks = []
      vue.searchResultsStations = []

      vue.$http
        .post(
          config.url.search,
          {
            term: query,
          },
          {
            headers: auth.getAuthHeader(),
          }
        )
        .then(
          function (response) {
            this.showSpinner = false

            $.each(response.body.data, (k, v) => {
              if (k === 'episodes' && response.body.data.episodes.length > 0) {
                for (const element of v) {
                  vue.searchResultsEpisodes.push({
                    id: element.id,
                    title: element.title,
                    image: isValidUrl(element.image) ? element.image : config.image.episode.thumb + element.image,
                    podcast_id: element.podcast_id,
                    author: element.author.name,
                    created: element.created,
                  })
                }
              } else if (k === 'podcasts' && response.body.data.podcasts.length > 0) {
                for (const data of v) {
                  vue.searchResultsPodcasts.push({
                    id: data.id,
                    slug: data.slug,
                    title: data.title,
                    image: isValidUrl(data.images.main)
                      ? data.images.main
                      : config.image.podcast.thumb + data.images.main,
                    category: data.category && data.category.title,
                    author: data.author.name,
                    created: data.created,
                  })
                }
              } else if (k === 'categories' && response.body.data.categories.length > 0) {
                for (const element of v) {
                  vue.searchResultsCategories.push({
                    id: element.id,
                    title: element.title,
                  })
                }
              } else if (k === 'networks' && response.body.data.networks.length > 0) {
                v.forEach((item) => {
                  vue.searchResultsNetworks.push({
                    id: item.network_id,
                    name: item.network_name,
                    ownerName: item.owner_name,
                    image: isValidUrl(item.image_main) ? item.image_main : config.image.network.cover + item.image_main, // There are no thumbnails for networks
                    slug: item.slug,
                  })
                })
              } else if (k === 'stations' && response.body.data.stations.length > 0) {
                v.forEach((item) => {
                  vue.searchResultsStations.push({
                    id: item.station_id,
                    name: item.station_name,
                    ownerName: item.owner_name,
                    image: isValidUrl(item.image_main) ? item.image_main : config.image.station.main + item.image_main,
                    slug: item.slug,
                  })
                })
              }
            })

            vue.noSearchResults =
              vue.searchResultsEpisodes.length === 0 &&
              vue.searchResultsPodcasts.length === 0 &&
              vue.searchResultsNetworks.length === 0 &&
              vue.searchResultsStations.length === 0
            $('.search-results').slideDown()
          },
          function (error) {
            this.$log.debug(error)
            this.$notify({
              title: 'Error fetching search results',
              text: this.getErrorMessage(error),
              type: 'error',
            })
          }
        )
    },
    searchEpisodeLink(podcastId, episodeId) {
      this.$router.push({
        path: `/podcast/${podcastId}/episode/${episodeId}`,
        params: { podcastId, episodeId },
      })
      // event.$emit('loadAudioEpisode',episodeId)
    },
    setLoginType(type) {
      this.lt = type
    },
    updatelt(type) {
      this.lt = type
    },
    openMobileLogin() {
      document.getElementById('mobile-login-menu').className += 'open'
    },
    mobileLoginClose() {
      document.getElementById('mobile-login-menu').classList.remove('open')
    },
    listenerAccount() {
      document.getElementById('listener-account-mobile').className += ' open'
    },
    listenerAccountClose() {
      document.getElementById('listener-account-mobile').classList.remove('open')
    },
    fetchSaveFollow() {
      this.$http
        .get(config.url.listener_dashboard, {
          params: {},
          headers: auth.getAuthHeader(),
        })
        .then(
          () => {},
          function (error) {
            if (error.status === '401') {
              auth.logout(this)
            }
          }
        )
    },
    collapseAllNavbars() {
      $('.navbar-collapse').collapse('hide')
    },
  },
}
window.AF_ENV = process.env
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/functions';

.menu-item-podcaster {
  position: relative;
}

.menu-item-podcaster::before {
  position: absolute;
  top: -5px;
  left: -15px;
  width: 2px;
  height: 32px;
  content: '';
  background: #2188bf;

  @media (min-width: 992px) and (max-width: 1200px) {
    left: -10px;
  }
}

.navbar-default {
  .navbar-nav {
    > li {
      .dropdown-menu {
        li.active {
          a {
            color: #fff !important;
            text-decoration: none !important;
            background-color: #f2765d !important;
            outline: 0 !important;
          }
        }
      }

      &:hover {
        > a {
          &::after {
            @media (min-width: 280px) and (max-width: 365px) {
              top: 107px;
            }

            @media (min-width: 366px) and (max-width: 950px) {
              top: 66px;
            }
          }
        }
      }
    }

    .open {
      .dropdown-menu {
        > li {
          > a {
            @media (min-width: 280px) and (max-width: 950px) {
              z-index: 2 !important;
              padding: 15px 0;
              font-size: to-rem(22);
              font-weight: 700;
              line-height: 1.2;
              color: #fff !important;
              text-decoration: none !important;
              outline: 0 !important;
            }
          }
        }
      }
    }

    > li.active {
      > a {
        &::after {
          @media (min-width: 280px) and (max-width: 365px) {
            top: 107px;
          }

          @media (min-width: 365px) and (max-width: 950px) {
            top: 66px;
          }
        }
      }
    }

    .menu-item-podcaster {
      .dropdown-toggle {
        .user-name {
          @media (min-width: 280px) and (max-width: 950px) {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: to-rem(34);
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import 'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500&display=swap';
@import 'assets/scss/base/variables';
@import 'assets/scss/base/functions';
@import './../assets/scss/styles';

.appDarkBackground {
  background-color: $color-nation-dark;
}

.custom-notification {
  padding: 15px 10px;
  margin: 10px 10px 0 0;
  font-size: to-rem(14);
  color: $color-white;
  background: $notification-blue;
  border-left: 5px solid $notification-border-blue;

  &.warn {
    background: $notification-warn;
    border-left-color: $notification-border-warn;
  }

  &.error {
    background: $notification-error;
    border-left-color: $notification-border-error;
  }

  &.success {
    background: $notification-success;
    border-left-color: $notification-border-success;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue